import React from 'react';

import { Snackbar } from '@mui/joy';

import { useGlobalStore } from '../stores/useGlobalStore';

const SnackBar: React.FC = () => {
  const snackbar = useGlobalStore((s) => s.snackbar);
  const setSnackbar = useGlobalStore((s) => s.setSnackbar);

  const handleClose = () => {
    setSnackbar({ message: '' });
  };

  return (
    <Snackbar
      open={!!snackbar.message}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={3000}
      color={snackbar.color || 'neutral'}
      variant='outlined'
    >
      {snackbar.message}
    </Snackbar>
  );
};

export default SnackBar;
